import React from "react";
import { Button, Table } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import {
  ADD_SCREENING_LABEL,
  EMPTY_PURCHASES_LABEL,
  PURCHASE_HISTORY_TITLE,
  getPurchaseSummaryText,
} from "../../constants";
import DetailsCard from "../DetailsCard/DetailsCard";
import { PURCHASE_HISTORY_COLUMNS } from "./columns";
import classes from "./PurchaseHistory.module.scss";

const PurchaseHistory = ({ purchases, purchasedCount, consumedCount }) => (
  <DetailsCard
    title={PURCHASE_HISTORY_TITLE}
    summary={getPurchaseSummaryText(purchasedCount, consumedCount)}
    action={
      // TODO: definir ação do botão — ver SPRINT.md seção 14.2
      <Button className={classes.AddScreeningButton} icon={<PlusOutlined />}>
        {ADD_SCREENING_LABEL}
      </Button>
    }
  >
    <Table
      columns={PURCHASE_HISTORY_COLUMNS}
      dataSource={purchases}
      locale={{ emptyText: EMPTY_PURCHASES_LABEL }}
      pagination={false}
      rowKey="id"
      tableLayout="fixed"
    />
  </DetailsCard>
);

export default PurchaseHistory;
